import { SiGithub } from "@react-icons/all-files/si/SiGithub";
import { SiLinkedin } from "@react-icons/all-files/si/SiLinkedin";
import { SiTwitter } from "@react-icons/all-files/si/SiTwitter";
import { EnvelopeIcon } from "@heroicons/react/24/solid";

export const SOCIAL_ACCOUNTS = {
  Mail: {
    name: "Email",
    href: "mailto:karan181716@gmail.com",
    Icon: ({ className = "" }) => <EnvelopeIcon className={className} />,
  },
  github: {
    name: "GitHub",
    href: "https://github.com/karandesai24/",
    Icon: ({ className = "" }) => <SiGithub className={className} />,
  },
  linkedin: {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/karan-desai-80b7a4148/",
    Icon: ({ className = "" }) => <SiLinkedin className={className} />,
  },
  twitter: {
    name: "Twitter",
    href: "https://twitter.com/Karandesai09",
    Icon: ({ className = "" }) => <SiTwitter className={className} />,
  },
};
